export enum ApplicationStatus {
  COMPLIANT = 'compliant',
  NOTCOMPLIANT = 'not-compliant',
  NEEDSREVIEW = 'needs-review',
  ERROR = 'server-error',
  INPROGRESS = 'in-progress',
}
